import { render, staticRenderFns, recyclableRender, components } from "./qiun-loading.vue?vue&type=template&id=1c4fd998&"
var renderjs
import script from "./qiun-loading.vue?vue&type=script&lang=js&"
export * from "./qiun-loading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/qiun-data-charts/components/qiun-loading/qiun-loading.vue"
export default component.exports